import {
	appPath,
	userDetailSitePath,
	userModelAccess,
	usersPath,
} from "helpers/routePaths";

import i18n from "i18n";

/**
 * NOTE: This is currently a helper. In production, this data may come from either the API
 * or can be hard coded. Probably not approproate as a helper function
 */
const userNavigation = (id) => {
	// Setting navigation links with correct application ID
	const userdetail = `${appPath}${usersPath}/${id}`;
	const navigation = [
		{
			name: i18n.t("title.details"),
			main: "Details",
			url: userdetail,
		},
		{
			name: i18n.t("label.sites"),
			main: "Sites",
			url: userdetail + userDetailSitePath,
		},
		{
			name: i18n.t("label.modelAccess"),
			main: "Model Access",
			url: userdetail + userModelAccess,
		},
	];

	return navigation;
};

export default userNavigation;
